import { Alert, Box, Divider, Modal, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, SkeletonText, Text } from '@chakra-ui/react';
import { useResource } from 'hooks/useResource';
import { useAgendaContext } from '../contexts/AgendaContext';
import FormConnectNoteTopicToLists from '../forms/FormConnectNoteTopicToLists';

interface ModalConnectTopicToListsProps {
  topicId: string;
}

export default function ModalConnectTopicToLists({ topicId }: ModalConnectTopicToListsProps) {
  const { modals: { connectTopicToLists }, onCloseConnectTopicToLists } = useAgendaContext();
  const { data: topic, isLoading } = useResource({ id: topicId as string, resourceName: 'topic', path: 'note-topics' });

  return (
    <Modal 
      variant="form"
      isOpen={connectTopicToLists.isOpen} 
      onClose={onCloseConnectTopicToLists}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          Associar Listas
          <span>Selecione as listas que receberão esse tópico:</span>
        </ModalHeader>
        <ModalCloseButton />

        <SkeletonText isLoaded={!isLoading}>
          { topic && (
          <>
            <Box mt="20px" px="20px">
              <Alert status="success" variant="left-accent">
                <Text dangerouslySetInnerHTML={{
                  __html: topic?.text
                }}></Text>
              </Alert>
            </Box>

            <Divider mt="20px" mb="10px" />

            <FormConnectNoteTopicToLists topic={topic} />
          </>
          )}
        </SkeletonText>
      </ModalContent>
    </Modal>
  )
}